import {useEffect,useRef,type RefObject} from 'react';
import {useUi} from './config';

export function useIncreaseEmphasis(ref:RefObject<HTMLElement|null>,value:number|undefined,identity:string,{effect='shine',disabled=false,numberSelector,surfaceSelector}:{effect?:'shine'|'weight';disabled?:boolean;numberSelector?:string;surfaceSelector?:string}={}){
 const durationToken=useUi().tokens['--room-jackpot-shine-duration'];
 const previous=useRef({value,identity});
 useEffect(()=>{
  const before=previous.current;previous.current={value,identity};
  const preference=matchMedia('(prefers-reduced-motion: reduce)');
  if(identity!==before.identity||value===undefined||before.value===undefined||value<=before.value||disabled||document.hidden||preference.matches)return;
  const time=/^(\d+(?:\.\d+)?)\s*(ms|s)$/.exec(durationToken.trim());
  const duration=time?Number(time[1])*(time[2]==='s'?1000:1):0;
  const number=numberSelector?ref.current?.querySelector<HTMLElement>(numberSelector):ref.current;
  const light=surfaceSelector?ref.current?.querySelector(surfaceSelector):null;
  if(!duration||!number)return;
  const style=getComputedStyle(number);
  if(effect==='shine')number.style.setProperty('--increase-ink',style.color);
  const weight=Number(style.fontWeight)||400;
  const options={duration,easing:'ease-in-out'};
  const frames=effect==='weight'
   ?[{fontWeight:weight,transform:'scale(1)'},{fontWeight:Math.min(900,Math.max(800,weight+300)),transform:'scale(1.14)',offset:.5},{fontWeight:weight,transform:'scale(1)'}]
   :[{backgroundPosition:'100% 100%',color:'transparent'},{backgroundPosition:'0% 0%',color:'transparent'}];
  const animations=[number.animate(frames,options)];
  if(light)animations.push(light.animate([{backgroundPosition:'100% 100%',opacity:0},{opacity:1,offset:.2},{opacity:1,offset:.8},{backgroundPosition:'0% 0%',opacity:0}],options));
  const cancel=()=>animations.forEach(animation=>animation.cancel());
  const stopIfNeeded=()=>{if(document.hidden||preference.matches)cancel();};
  document.addEventListener('visibilitychange',stopIfNeeded);preference.addEventListener('change',stopIfNeeded);
  return()=>{cancel();document.removeEventListener('visibilitychange',stopIfNeeded);preference.removeEventListener('change',stopIfNeeded);};
 },[value,identity,effect,disabled,durationToken,ref,numberSelector,surfaceSelector]);
}
